import React from "react";
import Card from "./card";

const ProjectList = ({projects, keyBase, limit}) => (
  <>
    {projects.map((item, i) => (
      i < (limit || projects.length) && <Card key={`${keyBase}-${i}`} image={item.featureImage[0]} title={item.title} subtitle={item.summary} href={`/${item.uri}`} color={1}/>
    ))}
  </>
);

export default ProjectList;